import Utils from '../../../utils/util';
import Config from '../../../config/index';

const defaultLayerHeight: PhysicsMeasurement = Config.get({
    moduleName: 'layer',
    key: 'defaultLayerHeight'
});
const defaultModuleHeight: PhysicsMeasurement = Config.get({
    moduleName: 'layer',
    key: 'defaultModuleHeight'
});

function getBeamLayerInfo(cubeData: FreeObjMap): BeamLayerInfo {
    let layerHeightKey: string = Config.get({
        moduleName: 'layer',
        key: 'keyMap.layerHeight'
    });
    let moduleHeightKey: string = Config.get({
        moduleName: 'layer',
        key: 'keyMap.moduleHeight'
    });
    let layerHeightValue: any = Utils.getMapValueByStringKey(cubeData, layerHeightKey);
    let layerHeight: PhysicsMeasurement = Utils.toNumberForce(layerHeightValue);
    let moduleHeightValue: any = Utils.getMapValueByStringKey(cubeData, moduleHeightKey);
    let moduleHeight: PhysicsMeasurement = Utils.toNumberForce(moduleHeightValue);

    if (layerHeight < 0) {
        layerHeight = defaultLayerHeight;
    }

    if (moduleHeight <= 0) {
        moduleHeight = defaultModuleHeight;
    }

    return {
        layerHeight,
        moduleHeight
    };
}

export {
    getBeamLayerInfo
};
